<template>
  <section class="sec-exhibitor">
    <div class="module_title">
      <span class="en">{{ en }}</span>
      <span class="num" :class="`num_${index}`" />
      <span class="tit">展商信息</span>
      <span class="en">{{ en }}</span>
    </div>
    <div class="box-sizing-wrapper">
      <div class="float-bg" />
      <div class="box-sizing-main">
        <img :src="data" alt="" />
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    index: {
      type: Number,
      default: 1,
    },
    en: {
      type: String,
      default: '',
    },
    data: {
      type: String,
      default: '',
    },
  },
  methods: {},
}
</script>
<style lang="less">
.sec-exhibitor {
  width: 1081px;
  margin: 0 auto 46px;
  .box-sizing-wrapper {
    position: relative;
    margin-top: 45px;
    .float-bg {
      width: 464px;
      height: 201px;
      top: -85px;
      right: -190px;
    }
  }
}
</style>
